import { useTranslation } from 'react-i18next';

export interface MoneyProps {
    amount: number | string;
    symbol: string;
    position: 'before' | 'after';
    className?: string;
}

/** Amount in the restaurant's currency, number formatted for the UI language. */
export const Money = ({ amount, symbol, position, className }: MoneyProps) => {
    const { i18n } = useTranslation();
    const value = new Intl.NumberFormat(i18n.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
        Number(amount)
    );
    return <span className={`tabular-nums ${className ?? ''}`}>{position === 'before' ? `${symbol}${value}` : `${value}\u00a0${symbol}`}</span>;
};
